import { ActionIcon } from "@mantine/core";
import { IconRotate } from '@tabler/icons-react';

export interface UndoProps {
    onClick: () => void;
}
const Undo: React.FC<UndoProps> = ({onClick}) => {
    return (
        <ActionIcon variant='filled' color='black' size='lg' radius='xl' aria-label='Undo' style={{ position: 'absolute', bottom: 'calc(33vh + 60px)', right: 20 }} onClick={onClick} >
            <IconRotate color='#B3B3B3' stroke={1.5} height={20} style={{ alignSelf: 'center', transform: 'rotate(90deg)' }} />
        </ActionIcon>
    );
}

export default Undo;